import { Property } from "../../models/contador";
import { fetchFromContador } from "./contador-fetch";
import type { GResponse } from "../../models/common.ts";
import type { PropertiesSearchRequest } from "../../models/search";

type PropertyPatch = Partial<Pick<Property, "properScope">> & Record<string, unknown>;

export async function patchProperty(
    propertyId: string,
    payload: PropertyPatch,
): Promise<Property | undefined> {
    try {
        return await fetchFromContador<Property>(`/api/v1/properties/${propertyId}`, {
            method: "PATCH",
            body: JSON.stringify(payload),
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function bulkSetProperScope(
    customerId: string,
    enabled: boolean,
    propertyIds: string[],
): Promise<void> {
    await fetchFromContador(`/api/v1/customers/${customerId}/properties/proper-scope`, {
        method: "PATCH",
        body: JSON.stringify({ enabled, property_ids: propertyIds }),
    });
}

export async function searchPropertiesV2(
    payload: PropertiesSearchRequest,
): Promise<GResponse<Property> | undefined> {
    try {
        return await fetchFromContador<GResponse<Property>>("/api/v2/properties/search", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
    } catch (e) {
        console.error(e);
        return undefined;
    }
}
